export default __webpack_public_path__ + "static/oops-1c4fee3750a3fb1db56704c933e53ac2.png";